import axios from "axios";

export const AUTHORIZATION = 'Authorization';
export const BEARER = '';
export const EDITION = '1.1.0'; // 版本
export const SYSTEM_NAME = '叭吧短剧后台管理平台'; ///系统名称
export const COMPANY = '海南叭吧传媒有限公司'; // 公司名
export const SUPPORT = '快科（天津）科技发展有限公司';
export const PHONE = '1311111111'; // 联系方式
export const RECORD_NUMBER = '琼ICP备2024033170号'; //备案号
export const QUERY = 'QUERY';

export const SYS_BASE_URL = '/playlet-service';
export const FZ_BASE_URL = '/fz-service';
export const SYS_BASE_URL_ZH = '/zh-service';

export const CREATE = 'success';
export const UPDATE = 'primary';
export const DELETE = 'danger';
export const DETAIL = 'info';
export const UNBIND = 'unbind';
export const BIND = 'bind';
export const UNBIND_API = 'unbindApi';
export const BIND_API = 'bindApi';

export const SYS_DEF = "00";